<template>
  <div class="container">
    <headBox title="人核单" ></headBox>
    <div class="info-content">
      <!-- 搜索部分 -->
      <topSearchForm @search="queryOrderlList" :hiddenExport="!['2','3'].includes(userinfo.level)||!checkAuth('orderExport')" 
        @export="exportToExcel" :showSwtich="!['3'].includes(userinfo.level)">
        <el-form :inline="true" class="rform" :model="selectForm" ref="rhform">
          <el-form-item label="创建日期" class="small">
            <a-range-picker class="only-date-picker" v-model="selectForm.dateTime" format="yyyy-MM-DD" valueFormat="yyyy-MM-DD  HH:mm:ss" separator="至">
              <i class="icon-riqixuanze" slot="suffixIcon"></i>
            </a-range-picker>
          </el-form-item>
          <el-form-item label="产品名称" class="small1">
            <el-input v-model="selectForm.productName" placeholder="请输入" clearable class="only-input"></el-input>
          </el-form-item>
          <el-form-item label="订单号" class="small2">
            <el-input class="only-input" v-model="selectForm.orderNum" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="是否支付" class="small">
            <el-radio-group v-model="selectForm.payment" @change="queryOrderlList()">
              <el-radio label="">全部</el-radio>
              <el-radio label="1,4,5,6,7,8,-9">未支付</el-radio>
              <el-radio label="2,3,9">已支付</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="" class="small4">
            <div class="cell-border">
              <el-select class="left-select" v-model="selectForm.policyHolder" placeholder="投保人">
                <el-option label="投保人" value="1"></el-option>
                <el-option label="被保人" value="2"></el-option>
              </el-select>
              <el-input class="right-input" type="text" v-model="selectForm.nameOrPh" placeholder="姓名/手机号" clearable></el-input>
            </div>
          </el-form-item>
          <el-form-item label="人核状态" class="small3">
            <el-select
              v-model="selectForm.manualKey"
              placeholder="全部"
              class="only-select"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="核保成功" value="1,2,3,5,9,-9"></el-option>
              <el-option label="核保失败" value="4,6"></el-option>
              <el-option label="核保中" value="7"></el-option>
              <el-option label="已撤销" value="8"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" v-if="!['2','3'].includes(userinfo.level)">
            <div class="cell-border">
              <el-select class="left-select" v-model="selectForm.level" @change="selectForm.mechanId='';getChildList()" placeholder="出单机构">
                <el-option label="出单机构" value="2"></el-option>
                <el-option label="出单员工" value="3"></el-option>
              </el-select>
              <el-select class="right-select" v-model="selectForm.mechanId" clearable filterable>
                <el-option :label="dept.shortName" :value="dept.id" v-for="(dept,index) in selectList" :key="index"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <!-- 只有二级机构显示 -->
          <el-form-item label="出单员工" v-if="userinfo.level==2">
            <el-select v-model="selectForm.mechanId" clearable filterable>
              <el-option :label="dept.shortName" :value="dept.id" v-for="(dept,index) in selectList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属部门" v-if="userinfo.level!=3&&selectForm.level==3">
            <el-cascader :options="deptList" v-model="selectForm.departmentId" :props="cascaderProps" :show-all-levels="false" filterable clearable></el-cascader>
          </el-form-item>
        </el-form>
      </topSearchForm>
      <!-- 二级机构员工显示 -->
      <div class="list-second" v-if="['2','3'].includes(userinfo.level)">
        <rhd-card :orderList="orderList" :selectForm="selectForm" v-if="orderList" ref="child" v-loading="loading"></rhd-card>
      </div>
      <!-- 二级机构员工不显示 -->
      <div class="list" v-if="!['2','3'].includes(userinfo.level)">
        <el-tabs v-model="activeName" @tab-click="handlePaneClick">
          <el-tab-pane label="全部人核单" name="1">
            <rhd-card :orderList="orderList" :selectForm="selectForm" v-if="orderList" ref="child" v-loading="loading"></rhd-card>
          </el-tab-pane>
          <el-tab-pane label="我的人核单" name="2"
            ><rhd-card :orderList="orderList" :selectForm="selectForm" v-if="orderList" ref="child1" v-loading="loading"></rhd-card
          ></el-tab-pane>
          <el-tab-pane label="下级机构人核单" name="3" v-if="userinfo.isOpenMechanism==1"
            ><rhd-card :orderList="orderList" :selectForm="selectForm" v-if="orderList" ref="child2" v-loading="loading"></rhd-card
          ></el-tab-pane>
          <el-tab-pane label="员工人核单" name="4"
            ><rhd-card :orderList="orderList" :selectForm="selectForm" v-if="orderList" ref="child3" v-loading="loading"></rhd-card
          ></el-tab-pane>
        </el-tabs>
        <el-button class="derive-btn" type="primary" @click="exportToExcel" plain v-if="checkAuth('orderExport')">导出</el-button>
      </div>
      <el-pagination
        v-if="pageFlag"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="allData.current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="allData.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="allData.total"
      >
      </el-pagination>
    </div>
    <helpTool type="orderRH"></helpTool>
  </div>
</template>

<script>
import headBox from "@/components/head.vue";
import topSearchForm from '@/components/topSearchForm.vue'
import rhdCard from "./components/order_rhd_card";
import helpTool from "@/components/helpTool.vue";
import {common} from "@/api/mixins";
export default {
  mixins: [common],
  data: () => ({
    pageFlag:false,
    loading:true,
    pageNum: 1,
    pageSize: 10,
    allData: {}, // 全部数据
    orderList: [], // 人核单列表
    childrenRefs:[],// ref元素列表
    activeName: "1",
    mechanType: "1", // 类型
    downFlag: true, // true为'展开查询',false为'收起查询'
    closeRow: false, // fales为隐藏一行筛选框,true为打开
    selectForm: {
      dateTime: [], // 创建日期
      productName: "", // 产品名称
      nameOrPh: "", // 姓名或者手机
      policyHolder: "1", // 投保人
      manualKey: "", // 人核状态
      payment: "", // 是否支付
      orderNum: "", // 订单号
      manualVal:"",// 核保状态
      level:'2',// 2出单机构/3出单员工
      mechanId:'', // 出单机构员工id
      departmentId:'', // 部门id
    },
    userinfo:{},
    // screenWidth: document.body.clientWidth, // 屏幕宽度
    timer: false,
    selectList:[],// 出单机构/员工列表
    deptList:[], // 部门列表
    cascaderProps: {
      checkStrictly: true, //是否严格的遵守父子节点不互相关联
      value: 'deptId', //指定选项的值为选项对象的某个属性值
      label: 'deptmantName', //指定选项标签为选项对象的某个属性值
      emitPath: false, //在选中节点改变时，是否返回由该节点所在的各级菜单的值所组成的数组，若设置 false，则只返回该节点的值
    },
  }),
  mounted() {
    this.getManualList();
  },
  created() {
    let begin=new Date();
    let end=new Date();
    begin = begin.getTime() - 29*24*3600*1000
    let timeArr = []
    timeArr[0]=this.$tools.formatDate(begin)
    timeArr[1]=this.$tools.formatDate(end)
    this.selectForm.dateTime = timeArr
    this.getUserInfo()
  },
  methods: {
    // 获取部门列表
    getDeptList() {
      this.$http({
        url: '/master/mechanDept/deptSelectTree',
        type: 'PUT',
        params: {},
      }).then((res) => {
        this.deptList = this.handleDeptTree(res.data)
      })
    },
    // 处理为空的children，el-cascader为空的数组会展示暂无数据
    handleDeptTree(data){
     let val = data.map(item=>{
        if(item.children.length==0){
          item.children=''
        }else{
          this.handleDeptTree(item.children)
        }
        return item
      })
      return val
    },
    // 获取机构/员工列表
    getChildList(){
      let param = {
        level:this.selectForm.level,
      }
      // 选中出单机构这个才传值
      if(this.selectForm.level==2){
        param.includeFirst='1'
      }
      this.$http({
        url:'/master/mechan/queryChildList',
        type:'PUT',
        params:param,
      }).then(res=>{
        if(res.httpCode==200){
          this.selectList=res.data
        }
      }).catch(e=>{})
    },
    //导出
    exportToExcel(){
      let endTime = this.selectForm.dateTime.length!=0 ? this.selectForm.dateTime[1] : "";
      let startTime = this.selectForm.dateTime.length!=0
        ? this.selectForm.dateTime[0]
        : "";
      let policyerKey =
        this.selectForm.policyHolder == "1" ? this.selectForm.nameOrPh : "";
      let insuranceKey =
        this.selectForm.policyHolder == "2" ? this.selectForm.nameOrPh : "";
      // 替换逗号
      let payMent = this.selectForm.payment
      if(payMent!=""&&payMent!=null){
        payMent=payMent.replace(/,/g,'$')
      }
      let manualKey = this.selectForm.manualKey
      if(manualKey!=""&&manualKey!=null){
        manualKey=manualKey.replace(/,/g,'$')
      }
      let url =
        this.$config.api_root +`/master/order/exportManualList?endTime=${endTime}&startTime=${startTime}&productName=${this.handleProductName(this.selectForm.productName)}&policyerKey=${policyerKey}&insuranceKey=${insuranceKey}&orderStatus=${manualKey}&id=${this.selectForm.orderNum}&mechanId=${this.selectForm.mechanId}&orderStatusArr=${payMent}&departmentId=${this.selectForm.departmentId?this.selectForm.departmentId:''}&mechanType=${this.mechanType}`;
     // 当前页面下载
      this.$tools.daochu(url)
    },
    getUserInfo(){
      const data = this.$tools.getLocal("userinfo");
      this.userinfo = this.$tools.getLocal("userinfo");
      // 1一级机构 2二级机构 3员工
      // 员工账号不请求这两个接口
      if(data.level!=3){
        this.getDeptList() // 获取部门列表
      }
      if(data.level==1){
        // 一级机构默认出单机构
        this.selectForm.level='2'
        this.getChildList()// 获取出单机构列表
      }else if(data.level==2){
        //二级机构没有出单机构，默认出单员工
        this.selectForm.level='3'
        this.getChildList()// 获取出单员工列表
      }
    },
    // 查询
    queryOrderlList() {
      // 将当前页重置为1
      this.pageNum=1
      this.getManualList();
    },
    clickOpenOrClose() {
      this.downFlag = !this.downFlag;
      this.closeRow = !this.closeRow;
    },
    // 人核订单列表
    getManualList() {
      this.loading=true
      let params ={
          endTime: this.selectForm.dateTime.length!=0 ? this.selectForm.dateTime[1].split(' ')[0] : "",
          startTime: this.selectForm.dateTime.length!=0
            ? this.selectForm.dateTime[0].split(' ')[0]
            : "",
          productName: this.selectForm.productName,
          policyerKey:
            this.selectForm.policyHolder == "1" ? this.selectForm.nameOrPh : "", // 搜索默认为投保人
          insuranceKey:
            this.selectForm.policyHolder == "2" ? this.selectForm.nameOrPh : "",
          orderStatus: this.selectForm.manualKey, // 人核状态
          id: this.selectForm.orderNum,
          mechanId: this.selectForm.mechanId,
          orderStatusArr: this.selectForm.payment, // 订单状态
          departmentId:this.selectForm.departmentId, // 部门id
          mechanType: this.mechanType, //  1全部人核单 2我的人核单 3下级机构人核单 4员工
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        for(var key in params){
          if(params[key] ==''){
            delete params[key]
          }
      }
      this.$http({
        url: "/master/order/manualList",
        type: "put",
        params: params,
      }).then((res) => {
        this.loading = false
        this.pageFlag = false
        this.allData = res;
        this.orderList = res.data;
        if(this.allData.total!=0){
          this.pageFlag = true
        }
      });
    },
    // panel 切换
    handlePaneClick(tab) {
      this.pageNum=1
      this.mechanType = tab.name;
      this.getManualList();
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getManualList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getManualList();
    },
    // 转译特殊字符
    handleProductName(name){
        return name.replace(/\+/g,'%2B').replace(/\-/g,'%2D').replace(/\(/g,"%28").replace(/\)/g,"%29").replace("\n","%20")
    }
  },
  components: {
    rhdCard,
    helpTool,
    topSearchForm,
    headBox
  },
};
</script>

<style lang='scss' scoped>
@import "./order_rhd";
// @import "./components/common_form";
</style>